import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './bcb-product-wizard.component.scss';
import axios from 'axios';
var varApplicationStarted = false;
var BcbProductWizard = /** @class */ (function (_super) {
    tslib_1.__extends(BcbProductWizard, _super);
    function BcbProductWizard(element) {
        return _super.call(this, element) || this;
    }
    BcbProductWizard.prototype.init = function () {
        this.endpointQuestions = "/sbutils/getContentListLinks";
        this.endpointResults = "/sbutils/getProductsList";
        // this.endpointQuestions = "https://invoice.imgraham.co.za/api/product-wizard/questions";
        // this.endpointResults = "https://invoice.imgraham.co.za/api/product-wizard/results";
        this.varModalLinks = Array.from(document.querySelectorAll('.js-bcb-product-wizard'));
        this.containerMainHeading = this.element.querySelector('.bcb-product-wizard__heading');
        this.containerQuestionaire = this.element.querySelector('.bcb-product-wizard__questionaire');
        this.containerQuestionaireDynamicHeading = this.element.querySelector('.js-questionaire-heading');
        this.containerQuestionaireDynamicDescription = this.element.querySelector('.js-questionaire-description');
        this.containerQuestionaireDynamicQuestions = this.element.querySelector('.js-questionaire-questions');
        this.containerResults = this.element.querySelector('.bcb-product-wizard__result');
        this.containerResultsDynamicHeading = this.element.querySelector('.js-results-heading');
        this.containerResultsDynamicDescription = this.element.querySelector('.js-results-description');
        this.containerResultsDynamicResults = this.element.querySelector('.js-results-dynamic');
        this.containerLoader = this.element.querySelector('.bcb-product-wizard__loader');
        this.containerBottomButtons = this.element.querySelector('.bcb-product-wizard__buttons');
        this.containerBottomButtonsQuestionaire = this.element.querySelector('.js-buttons-questionaire');
        this.containerBottomButtonsResults = this.element.querySelector('.js-buttons-results');
        this.containerProductWizard = Array.from(document.querySelectorAll('#product-wizard'));
        this.buttonCancel = Array.from(this.element.querySelectorAll('.js-button-cancel'));
        this.buttonPrevious = Array.from(this.element.querySelectorAll('.js-button-previous'));
        this.buttonNext = this.element.querySelector('.js-button-next');
        this.buttonClose = Array.from(this.element.querySelectorAll('.js-rich-text-modal-modal-close'));
        this.varPreviousItems = [];
        this.varAllItems = [];
    };
    BcbProductWizard.prototype.bindEvents = function () {
        var _this = this;
        if (this.varModalLinks) {
            this.varModalLinks.map(function (varModalLink) { return varModalLink.addEventListener('click', function (event) {
                var element = undefined;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                if (element.getAttribute('data-contentlistid')) {
                    _this.varContentListId = element.getAttribute('data-contentlistid');
                }
                if (element.getAttribute('data-sitename')) {
                    _this.varSiteName = element.getAttribute('data-sitename');
                }
                _this.buttonPrevious.map(function (button) {
                    button.classList.add('button--disabled');
                    button.classList.add('d-none');
                });
                if ((typeof dataLayer != 'undefined')) {
                    varApplicationStarted = false;
                    _this.varApplicationStep = 1;
                    _this.varApplicationId = _this.analyticsGenerateApplicationID();
                    dataLayer.application.applicationID = _this.varApplicationId;
                    dataLayer.application.applicationStep = 'step 1';
                }
                _this.varPreviousItems = [];
                _this.apiQuestions();
            }); });
        }
        if (this.buttonCancel) {
            this.buttonCancel.map(function (button) { return button.addEventListener('click', function (event) {
                if (typeof _satellite == 'object') {
                    _satellite.track("globalFormAbandon");
                }
                _this.closeModal();
            }); });
        }
        if (this.containerProductWizard) {
            this.containerProductWizard.map(function (container) {
                container.addEventListener('click', function (event) {
                    var element = event.target;
                    if (element.classList.contains('modal')) {
                        if (typeof _satellite == 'object') {
                            _satellite.track("globalFormAbandon");
                        }
                        _this.closeModal();
                    }
                });
                if (container.querySelector('.modal__close')) {
                    var closeModalButton = container.querySelector('.modal__close');
                    closeModalButton.addEventListener('click', function (event) {
                        if (typeof _satellite == 'object') {
                            _satellite.track("globalFormAbandon");
                        }
                        _this.closeModal();
                    });
                }
            });
        }
        if (this.buttonNext) {
            this.buttonNext.addEventListener('click', function (event) {
                if ((typeof dataLayer != 'undefined')) {
                    _this.varApplicationStep = _this.varApplicationStep + 1;
                    dataLayer.application.applicationStep = 'step ' + _this.varApplicationStep;
                }
                _this.varPreviousItems.push(_this.varContentListId);
                var getInputs = Array.from(_this.element.querySelectorAll('input[name=input]'));
                getInputs.map(function (input) {
                    if (input.checked) {
                        var getContentListId = input.value;
                        var getDataType = input.getAttribute('data-type');
                        _this.varContentListId = getContentListId;
                        if (getDataType === 'results') {
                            console.log(_this.varPreviousItems);
                            _this.containerBottomButtonsQuestionaire.classList.add('d-none');
                            _this.containerBottomButtonsResults.classList.remove('d-none');
                            _this.buttonPrevious.map(function (button) {
                                button.classList.remove('button--disabled');
                                button.classList.remove('d-none');
                            });
                            if (typeof _satellite == 'object') {
                                _satellite.track('globalFormComplete');
                                // _satellite.track("globalApplicationComplete");
                            }
                            _this.apiResults();
                        }
                        else {
                            _this.buttonNext.classList.add('button--disabled');
                            _this.buttonPrevious.map(function (button) {
                                button.classList.remove('button--disabled');
                                button.classList.remove('d-none');
                            });
                            if (typeof _satellite == 'object') {
                                _satellite.track('globalFormComplete');
                            }
                            _this.apiQuestions();
                        }
                    }
                });
            });
        }
        if (this.buttonPrevious) {
            this.buttonPrevious.map(function (button) { return button.addEventListener('click', function (event) {
                if ((typeof dataLayer != 'undefined')) {
                    _this.varApplicationStep = _this.varApplicationStep - 1;
                    dataLayer.application.applicationStep = 'step ' + _this.varApplicationStep;
                }
                _this.containerBottomButtonsResults.classList.add('d-none');
                _this.containerBottomButtonsQuestionaire.classList.remove('d-none');
                var existingArray = _this.varPreviousItems;
                _this.varContentListId = existingArray[existingArray.length - 1];
                existingArray.pop();
                _this.varPreviousItems = existingArray;
                _this.buttonNext.classList.add('button--disabled');
                if (_this.varPreviousItems) {
                    if (_this.varPreviousItems.length === 0) {
                        _this.buttonPrevious.map(function (button) {
                            button.classList.add('button--disabled');
                            button.classList.add('d-none');
                        });
                    }
                    else {
                        _this.buttonPrevious.map(function (button) {
                            button.classList.remove('button--disabled');
                        });
                    }
                }
                else {
                    _this.buttonPrevious.map(function (button) {
                        button.classList.add('button--disabled');
                        button.classList.add('d-none');
                    });
                }
                if (typeof _satellite == 'object') {
                    _satellite.track("globalFormAbandon");
                }
                _this.apiQuestions();
            }); });
        }
    };
    BcbProductWizard.prototype.apiQuestions = function () {
        var containerMainHeading = this.containerMainHeading;
        var containerQuestionaire = this.containerQuestionaire;
        var containerResults = this.containerResults;
        var containerQuestionaireDynamicHeading = this.containerQuestionaireDynamicHeading;
        var containerQuestionaireDynamicDescription = this.containerQuestionaireDynamicDescription;
        var containerQuestionaireDynamicQuestions = this.containerQuestionaireDynamicQuestions;
        var containerBottomButtons = this.containerBottomButtons;
        var containerLoader = this.containerLoader;
        var setupButtons = this.setupButtons;
        var buttonCancel = this.buttonCancel;
        var buttonPrevious = this.buttonPrevious;
        var buttonNext = this.buttonNext;
        containerQuestionaire.classList.add('d-none');
        containerResults.classList.add('d-none');
        containerBottomButtons.classList.add('d-none');
        containerLoader.classList.remove('d-none');
        // variables
        var postData = "";
        if (this.varContentListId) {
            postData += 'contentListID=' + this.varContentListId + '&';
        }
        if (this.varSiteName) {
            postData += 'siteName=' + this.varSiteName + '&';
        }
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        axios.post(this.endpointQuestions, postData, config).then(function (response) {
            var json = response.data;
            containerMainHeading.innerHTML = json.systemTitle;
            containerQuestionaireDynamicHeading.innerHTML = json.title;
            containerQuestionaireDynamicDescription.innerHTML = json.summary;
            containerQuestionaireDynamicQuestions.innerHTML = '';
            if ((typeof dataLayer != 'undefined')) {
                dataLayer.formName = json.systemTitle + ' | ' + json.title;
                buttonCancel.map(function (button) {
                    button.setAttribute('data-intent', 'navigational');
                    button.setAttribute('data-scope', 'body');
                    button.setAttribute('data-id', 'link_content');
                    button.setAttribute('data-text', json.systemTitle + ' | ' + json.title + ' | ' + 'cancel button click');
                });
                buttonPrevious.map(function (button) {
                    button.setAttribute('data-intent', 'navigational');
                    button.setAttribute('data-scope', 'body');
                    button.setAttribute('data-id', 'link_content');
                    button.setAttribute('data-text', json.systemTitle + ' | ' + json.title + ' | ' + 'previous button click');
                });
                buttonNext.setAttribute('data-intent', 'navigational');
                buttonNext.setAttribute('data-scope', 'body');
                buttonNext.setAttribute('data-id', 'link_content');
                buttonNext.setAttribute('data-text', json.systemTitle + ' | ' + json.title + ' | ' + 'next button click');
                if (!varApplicationStarted) {
                    var lowercaseSystemTitle = json.systemTitle.toLowerCase();
                    dataLayer.application.applicationName = 'application: ' + lowercaseSystemTitle;
                    if (typeof _satellite == 'object') {
                        _satellite.track("globalApplicationStart");
                    }
                    varApplicationStarted = true;
                }
            }
            var index = 0;
            var items = "";
            json.links.map(function (item) {
                var linkClassCustom = item.linkClassName.toLowerCase();
                if (linkClassCustom === 'nextstep' || linkClassCustom === 'results') {
                    index += 1;
                    items += "<div class=\"col-md-6\">\n\t\t\t\t\t\t<label for=\"" + item.linkToContentID + "_" + index + "\" class=\"bcb-product-wizard__questionaire--answers__answer\">\n\t\t\t\t\t\t\t" + item.linkText + "\n\t\t\t\t\t\t\t<input type=\"radio\" id=\"" + item.linkToContentID + "_" + index + "\" name=\"input\" value=\"" + item.linkToContentID + "\" data-type=\"" + linkClassCustom + "\" data-textcontent=\"" + item.linkText + "\" class=\"bcb-product-wizard__questionaire--answers__answer--input\">\n\t\t\t\t\t\t\t<span class=\"bcb-product-wizard__questionaire--answers__answer--checkmark\"></span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>";
                }
            });
            containerQuestionaireDynamicQuestions.innerHTML = items;
            setupButtons(buttonPrevious, buttonNext);
            containerLoader.classList.add('d-none');
            containerQuestionaire.classList.remove('d-none');
            containerBottomButtons.classList.remove('d-none');
        }).catch(function (response) {
            console.log(response);
        });
    };
    BcbProductWizard.prototype.apiResults = function () {
        var containerMainHeading = this.containerMainHeading;
        var containerQuestionaire = this.containerQuestionaire;
        var containerResults = this.containerResults;
        var containerResultsDynamicHeading = this.containerResultsDynamicHeading;
        var containerResultsDynamicDescription = this.containerResultsDynamicDescription;
        var containerResultsDynamicResults = this.containerResultsDynamicResults;
        var containerBottomButtons = this.containerBottomButtons;
        var containerLoader = this.containerLoader;
        var setupButtons = this.setupButtons;
        var buttonCancel = this.buttonCancel;
        var buttonPrevious = this.buttonPrevious;
        var buttonNext = this.buttonNext;
        containerQuestionaire.classList.add('d-none');
        containerResults.classList.add('d-none');
        containerBottomButtons.classList.add('d-none');
        containerLoader.classList.remove('d-none');
        if (containerResults.querySelector('.ViewAllOptions')) {
            var resultsContainer = containerResults.querySelector('.ViewAllOptions');
            containerResults.removeChild(resultsContainer);
        }
        // variables
        var postData = "";
        if (this.varContentListId) {
            postData += 'contentListID=' + this.varContentListId + '&';
        }
        if (this.varSiteName) {
            postData += 'siteName=' + this.varSiteName + '&';
        }
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        axios.post(this.endpointResults, postData, config).then(function (response) {
            var json = response.data;
            // containerMainHeading.innerHTML = json.systemTitle;
            // containerResultsDynamicHeading.innerHTML = json.title;
            containerMainHeading.innerHTML = json.title;
            containerResultsDynamicHeading.innerHTML = json.systemTitle;
            containerResultsDynamicDescription.innerHTML = json.summary;
            containerResultsDynamicResults.innerHTML = '';
            if ((typeof dataLayer != 'undefined')) {
                dataLayer.formName = json.systemTitle + ' | ' + json.title;
                buttonCancel.map(function (button) {
                    button.setAttribute('data-intent', 'navigational');
                    button.setAttribute('data-scope', 'body');
                    button.setAttribute('data-id', 'link_content');
                    button.setAttribute('data-text', json.systemTitle + ' | ' + json.title + ' | ' + 'cancel button click');
                });
                buttonPrevious.map(function (button) {
                    button.setAttribute('data-intent', 'navigational');
                    button.setAttribute('data-scope', 'body');
                    button.setAttribute('data-id', 'link_content');
                    button.setAttribute('data-text', json.systemTitle + ' | ' + json.title + ' | ' + 'previous button click');
                });
                buttonNext.setAttribute('data-intent', 'navigational');
                buttonNext.setAttribute('data-scope', 'body');
                buttonNext.setAttribute('data-id', 'link_content');
                buttonNext.setAttribute('data-text', json.systemTitle + ' | ' + json.title + ' | ' + 'next button click');
            }
            var index = 0;
            var items = "";
            json.products.map(function (item) {
                index += 1;
                var buttons = "";
                if (item.buttons.length > 0) {
                    buttons += "<div class=\"bcb-product-wizard__result--item__buttons\">";
                    buttons += "<div class=\"row\">";
                    item.buttons.map(function (buttonItem) {
                        var convertLinkClass = buttonItem.buttonClass;
                        convertLinkClass = convertLinkClass.toLowerCase();
                        if (convertLinkClass === 'productdetails') {
                            buttons += "<div class=\"col-md-6\"><a href=\"" + buttonItem.url + "\" data-intent=\"informational\" data-scope=\"body\" data-id=\"link_content\" data-text=\"" + (json.systemTitle + ' | ' + json.title + ' | ' + item.title + ' | ' + 'tell me more button click') + "\" class=\"button button--white button--border-blue js-bcb-product-wizard-application-complete\" target=\"_blank\">" + buttonItem.title + "</a></div>";
                        }
                        else {
                            if (convertLinkClass === 'apply' && buttonItem.isModal === false) {
                                buttons += "<div class=\"col-md-6\"><a href=\"" + buttonItem.url + "\" data-intent=\"transactional\" data-scope=\"body\" data-id=\"link_content\" data-text=\"" + (json.systemTitle + ' | ' + json.title + ' | ' + item.title + ' | ' + buttonItem.title + ' button click') + "\" class=\"button button--main js-bcb-product-wizard-application-complete\" target=\"_blank\">" + buttonItem.title + "</a></div>";
                            }
                        }
                    });
                    buttons += "</div>";
                    buttons += "</div>";
                }
                // pricing layout
                var pricing = "";
                var terms = [];
                if (item.pricing.length > 0) {
                    pricing += "<div class=\"bcb-product-wizard__result--item__description--attributes\"><div class=\"row\">";
                    item.pricing.map(function (pricingItem) {
                        var symbol = "";
                        var asterix = "";
                        if (pricingItem.symbol) {
                            symbol = "<span>" + pricingItem.symbol + "</span>";
                        }
                        if (pricingItem.terms) {
                            terms.push(pricingItem.terms);
                            for (var index_1 = 0; index_1 < terms.length; index_1++) {
                                asterix = asterix + '*';
                            }
                        }
                        pricing += "<div class=\"col-md-6\">\n\t\t\t\t\t\t\t<div class=\"bcb-product-wizard__result--item__description--attributes__attribute\">\n\t\t\t\t\t\t\t\t<div class=\"bcb-product-wizard__result--item__description--attributes__attribute--value\">\n\t\t\t\t\t\t\t\t\t<div class=\"title title--module-sub-title\">" + symbol + pricingItem.title + asterix + "</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"bcb-product-wizard__result--item__description--attributes__attribute--label\">\n\t\t\t\t\t\t\t\t\t<div class=\"title title--notes\">" + pricingItem.subTitle + "</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>";
                    });
                    pricing += "</div></div>";
                }
                // terms layout
                var termsLayout = "";
                if (terms.length > 0) {
                    var asterixes_1 = "";
                    termsLayout += "<div class=\"bodyText bcb-product-wizard__result--item__description--terms\">";
                    terms.map(function (term) {
                        asterixes_1 = asterixes_1 + '*';
                        termsLayout += "<div class=\"bodyText bcb-product-wizard__result--item__description--terms__term\">" + asterixes_1 + term + "</div>";
                    });
                    termsLayout += "</div>";
                }
                // parent layout
                items += "<div class=\"col-md-6\">\n\t\t\t\t\t<div class=\"bcb-product-wizard__result--item\">\n\t\t\t\t\t\t<div class=\"title title--module-sub-title bcb-product-wizard__result--item__title\">" + item.title + "</div>\n\t\t\t\t\t\t<div class=\"title title-gradient title-gradient--product\"></div>\n\t\t\t\t\t\t<div class=\"bcb-product-wizard__result--item__description\">\n\t\t\t\t\t\t\t<div class=\"bodyText bcb-product-wizard__result--item__description--text\">\n\t\t\t\t\t\t\t\t" + item.subTitle + "\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t" + pricing + "\t\t\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t" + termsLayout + "\n\t\t\t\t\t\t" + buttons + "\n\t\t\t\t\t</div>\n\t\t\t\t</div>";
            });
            containerResultsDynamicResults.innerHTML = items;
            // create all options
            if (json.links) {
                if (json.links.length > 0) {
                    var viewAllOptionsEnabled_1 = false;
                    var viewAllOptionsName_1 = '';
                    var viewAllOptionsLink_1 = '';
                    var viewAllOptionsHelpText_1 = '';
                    json.links.map(function (link) {
                        if (link.linkClassName === 'viewalloptions') {
                            viewAllOptionsEnabled_1 = true;
                            viewAllOptionsName_1 = link.linkText;
                            viewAllOptionsLink_1 = link.linkToChannel;
                            viewAllOptionsHelpText_1 = link.linkHelpText;
                        }
                    });
                    if (viewAllOptionsEnabled_1) {
                        var viewAllOptionsRow = document.createElement('div');
                        viewAllOptionsRow.classList.add('row');
                        viewAllOptionsRow.classList.add('ViewAllOptions');
                        viewAllOptionsRow.style.marginTop = '30px';
                        viewAllOptionsRow.style.marginBottom = '30px';
                        var viewAllOptionsColumn = document.createElement('div');
                        viewAllOptionsColumn.classList.add('col-md-12');
                        viewAllOptionsColumn.classList.add('text-center');
                        var viewAllOptionsTitle = document.createElement('div');
                        viewAllOptionsTitle.classList.add('title');
                        viewAllOptionsTitle.classList.add('title--module-sub-title');
                        viewAllOptionsTitle.innerHTML = "Not what you're looking for?";
                        var viewAllOptionsDescription = document.createElement('div');
                        viewAllOptionsDescription.classList.add('bodyText');
                        viewAllOptionsDescription.innerHTML = viewAllOptionsHelpText_1;
                        viewAllOptionsDescription.style.marginBottom = '15px';
                        var viewAllOptionsButton = document.createElement('a');
                        viewAllOptionsButton.style.display = 'inline-block';
                        viewAllOptionsButton.classList.add('button');
                        viewAllOptionsButton.classList.add('button--main');
                        viewAllOptionsButton.classList.add('js-bcb-product-wizard-application-complete');
                        viewAllOptionsButton.setAttribute('href', viewAllOptionsLink_1);
                        viewAllOptionsButton.setAttribute('data-intent', 'navigational');
                        viewAllOptionsButton.setAttribute('data-scope', 'body');
                        viewAllOptionsButton.setAttribute('data-id', 'link_content');
                        viewAllOptionsButton.setAttribute('data-text', json.systemTitle + ' | ' + json.title + ' | ' + viewAllOptionsName_1 + ' button click');
                        viewAllOptionsButton.innerHTML = viewAllOptionsName_1;
                        viewAllOptionsColumn.appendChild(viewAllOptionsTitle);
                        if (viewAllOptionsHelpText_1 === "null" || viewAllOptionsHelpText_1 === "" || viewAllOptionsHelpText_1 === undefined) {
                            console.log('no help text logged');
                        }
                        else {
                            console.log('help text logged');
                            viewAllOptionsColumn.appendChild(viewAllOptionsDescription);
                        }
                        viewAllOptionsColumn.appendChild(viewAllOptionsButton);
                        viewAllOptionsRow.appendChild(viewAllOptionsColumn);
                        containerResults.appendChild(viewAllOptionsRow);
                    }
                }
            }
            containerLoader.classList.add('d-none');
            containerResults.classList.remove('d-none');
            containerBottomButtons.classList.remove('d-none');
            // application complete
            var buttonsApplicationComplete = Array.from(document.querySelectorAll('.js-bcb-product-wizard-application-complete'));
            buttonsApplicationComplete.map(function (item) { return item.addEventListener('click', function (event) {
                _satellite.track("globalApplicationComplete");
            }); });
        }).catch(function (response) {
            console.log(response);
        });
    };
    BcbProductWizard.prototype.setupButtons = function (buttonPrevious, buttonNext) {
        if (buttonPrevious === void 0) { buttonPrevious = ""; }
        if (buttonNext === void 0) { buttonNext = ""; }
        var answered = false;
        var answers = Array.from(document.querySelectorAll('.bcb-product-wizard__questionaire--answers__answer--input'));
        answers.map(function (answer) { return answer.addEventListener('click', function (event) {
            var element = event.target;
            if (buttonNext.classList.contains('button--disabled')) {
                buttonNext.classList.remove('button--disabled');
            }
            var getText = element.getAttribute('data-textcontent');
            if ((typeof dataLayer != 'undefined')) {
                dataLayer.linkName = getText;
            }
            if (!answered) {
                if (typeof _satellite == 'object') {
                    _satellite.track('globalFormStart');
                }
            }
            answered = true;
        }); });
    };
    BcbProductWizard.prototype.closeModal = function () {
        // close modal
        var modals = Array.from(document.querySelectorAll('.modal'));
        modals.map(function (modal) {
            modal.classList.add('modal--close');
            modal.classList.add('modal--closed');
        });
        var containerMainHeading = this.containerMainHeading;
        containerMainHeading.innerHTML = '';
        var containerQuestionaire = this.containerQuestionaire;
        var containerQuestionaireDynamicHeading = this.containerQuestionaireDynamicHeading;
        var containerQuestionaireDynamicDescription = this.containerQuestionaireDynamicDescription;
        var containerQuestionaireDynamicQuestions = this.containerQuestionaireDynamicQuestions;
        containerQuestionaireDynamicHeading.innerHTML = '';
        containerQuestionaireDynamicDescription.innerHTML = '';
        containerQuestionaireDynamicQuestions.innerHTML = '';
        var containerResults = this.containerResults;
        var containerResultsDynamicHeading = this.containerResultsDynamicHeading;
        var containerResultsDynamicDescription = this.containerResultsDynamicDescription;
        var containerResultsDynamicResults = this.containerResultsDynamicResults;
        containerResultsDynamicHeading.innerHTML = '';
        containerResultsDynamicDescription.innerHTML = '';
        containerResultsDynamicResults.innerHTML = '';
        var containerBottomButtons = this.containerBottomButtons;
        containerBottomButtons.classList.remove('d-none');
        var containerBottomButtonsQuestionaire = this.containerBottomButtonsQuestionaire;
        containerBottomButtonsQuestionaire.classList.remove('d-none');
        var containerBottomButtonsResults = this.containerBottomButtonsResults;
        containerBottomButtonsResults.classList.add('d-none');
        var containerLoader = this.containerLoader;
        containerLoader.classList.add('d-none');
        var buttonCancel = this.buttonCancel;
        buttonCancel.map(function (button) {
            button.classList.remove('button--disabled');
        });
        var buttonPrevious = this.buttonPrevious;
        buttonPrevious.map(function (button) {
            button.classList.add('button--disabled');
        });
        var buttonNext = this.buttonNext;
        buttonNext.classList.add('button--disabled');
        buttonNext.classList.remove('d-none');
    };
    // Analytics
    BcbProductWizard.prototype.analyticsApplicationStart = function () {
        if (typeof _satellite == 'object') {
            _satellite.track("globalApplicationStart");
        }
    };
    BcbProductWizard.prototype.analyticsApplicationComplete = function () {
        if (typeof _satellite == 'object') {
            _satellite.track("globalApplicationComplete");
        }
    };
    BcbProductWizard.prototype.analyticsGenerateApplicationID = function () {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        var charactersLength = characters.length;
        var counter = 0;
        while (counter < 10) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
            counter += 1;
        }
        var timestamp = Math.floor(Date.now() / 1000);
        return timestamp + result;
    };
    return BcbProductWizard;
}(Base));
export { BcbProductWizard };



//////////////////
// WEBPACK FOOTER
// ./components/bcb-product-wizard/bcb-product-wizard.component.ts
// module id = 705
// module chunks = 0